import React, { useState } from 'react';

import Snackbar from '@asteria/component-snackbar';

import { TranslationService, useTranslationFn } from '@asteria/language';
import { cn } from '@asteria/utils-funcs/classes';

import './styles.scss';

const BookDemo = () => {
	const [showToast, setShowToast] = useState(true);

	const translate = useTranslationFn();

	const handleClose = React.useCallback(() => {
		setShowToast(false);
	}, []);

	return (
		showToast && (
			<div
				className={cn(
					'fixed bottom-36 right-8 z-40',
					'asteria-component__wrapper-snackbar',
				)}
			>
				<Snackbar
					variant="default"
					title={TranslationService.getV2(['snackbar.demo.title'], {
						default: 'Ready to transform your business?',
					})}
					content={TranslationService.getV2(['snackbar.demo.text'], {
						default:
							'Book a personalized 30-minute demo to see how our solution can help you succeed.',
					})}
					type="demo"
					onClose={handleClose}
					actions={[
						{
							variant: 'href',
							label: translate(['snackbar.demo.action.label']),
							href: translate('snackbar.demo.action.url', {
								default:
									'mailto:carl@asteria.com?subject=Book%20a%20Demo%20Request',
							}),
						},
					]}
				/>
			</div>
		)
	);
};

export default BookDemo;
